import Enllac from 'components/3catinfo/Enllac';
import Imatge from 'components/3catinfo/Imatge';
import styles from './destacatMapaAnimat.module.scss';

const DestacatMapaAnimat = (props) => {
    const { titol, link, imatge, slug, linkTipus } = props;

    const route = {
        href: link,
        type: linkTipus,
        slug: slug
    };

    const imatgeSrc = 'https://statics.3cat.cat/meteo' + imatge;

    return (
        <div className={styles.destacatMapaAnimat}>
            <Enllac route={route}>
                <div>
                    {imatge && (
                        <div className={styles.imatgeWrapper}>
                            <Imatge
                                src={imatgeSrc}
                                className={styles.imatge}
                                tipus='web_destacat'
                                alt={titol}
                                aria-hidden='true'
                                layout='fill'
                                objectFit='cover'
                                crop='1903'
                                data_testid='destacat-img'
                            />
                        </div>
                    )}

                    <h3 className={styles.titol}>{titol}</h3>
                </div>
            </Enllac>
        </div>
    );
};

export default DestacatMapaAnimat;
